/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Run_Time_LimitInputs */



/**
* | output |
* | --- |
* | "The response ran out of time and stopped before it was finished. Ask it to continue where it left off." |
*
* @param {Chat_Error_Run_Time_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_run_time_limit = /** @type {((inputs?: Chat_Error_Run_Time_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Run_Time_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Antwort hat das Zeitlimit erreicht und wurde vor dem Ende abgebrochen. Bitte die KI, dort weiterzumachen, wo sie aufgehört hat.")
	return /** @type {LocalizedString} */ ("The response ran out of time and stopped before it was finished. Ask it to continue where it left off.")
});